@if(visibilityStatus === VisibilityStatus.UNDER_SILENT_ADMIN_REVIEW && statusEnum === InvoiceStatus.IN_DISPUTED){
<!-- Under Admin Review and Data Disputed -->
<img src="assets/icons/status/error.svg" title="{{ 'shared.status_title.disputed' | transloco }}">
}
@else if(visibilityStatus === VisibilityStatus.UNDER_ADMIN_REVIEW){
<!-- Under Admin Review -->
<img src="assets/icons/status/review-blue.svg" title="{{ 'invoice.under_admin_review' | transloco }}">
}
@else if (statusEnum === InvoiceStatus.VALID || statusEnum === InvoiceStatus.DONE || status === true) {
<!-- Status OK SVG -->
<div title="{{ 'shared.status_title.ok' | transloco }}">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M10.0001 18.3337C14.5834 18.3337 18.3334 14.5837 18.3334 10.0003C18.3334 5.41699 14.5834 1.66699 10.0001 1.66699C5.41675 1.66699 1.66675 5.41699 1.66675 10.0003C1.66675 14.5837 5.41675 18.3337 10.0001 18.3337Z"
            [attr.fill]="statusOkColor" [attr.stroke]="statusOkColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6.45837 9.99993L8.81671 12.3583L13.5417 7.6416" stroke="white" stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</div>
}
@else if (statusEnum === InvoiceStatus.DATA_MISSING || statusEnum === InvoiceStatus.CALCULATION_FAILED) {
<!-- Warning SVG -->
<img src="assets/icons/status/warning.svg" title="{{ 'shared.status_title.warning' | transloco }}">
}
@else if (statusEnum === InvoiceStatus.IN_DISPUTED) {
<!-- Disputed SVG -->
<img src="assets/icons/status/error.svg" title="{{ 'shared.status_title.disputed' | transloco }}">
}
@else if (statusEnum === InvoiceStatus.IN_VALIDATION || statusEnum === InvoiceStatus.IN_PROCESSING) {
<!-- Validating SVG -->
<img src="assets/icons/status/validating.svg" title="{{ 'shared.status_title.validating' | transloco }}">
}
@else if (statusEnum === InvoiceStatus.CREATED) {
<!-- Data extraction SVG -->
<img src="assets/icons/status/loading.svg" title="{{ 'shared.status_title.extraction' | transloco }}">
}
@else {
<!-- Status Error SVG -->
<img src="assets/icons/status/error.svg" title="{{ 'shared.status_title.error' | transloco }}">
}